/* eslint-disable @typescript-eslint/no-explicit-any */
declare global {
  interface Window {
    fbq?: (...args: any[]) => void;
  }
}

/** Dispara un evento estándar de Meta Pixel (Lead, CompleteRegistration, etc.) */
export function fbTrack(event: string, params?: Record<string, unknown>) {
  (globalThis as any).fbq?.("track", event, params);
}

/** Dispara un evento personalizado de Meta Pixel */
export function fbTrackCustom(event: string, params?: Record<string, unknown>) {
  (globalThis as any).fbq?.("trackCustom", event, params);
}
